import styled from "styled-components";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

const FOOTER_IMAGE_MARGIN_TOP = "14px";
export const FooterImageContainer = styled.div(({ theme }) => ({
    margin: `${FOOTER_IMAGE_MARGIN_TOP} ${theme.spacing.medium} 0`,
}));

export const FooterImage = styled(Image)(({ theme }) => ({
    borderRadius: theme.cornerRadius.large,
    background: theme.colors[theme.colorMode].background_Primary,
}));
